var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "load-d",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13366",
    "data-name": "Path 13366",
    d: "M35.5,22.5H32.167a.667.667,0,1,0,0,1.333H35.5a.667.667,0,0,0,0-1.333Z",
    transform: "translate(-20.167 -15.167)",
    fill: "#868a97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13367",
    "data-name": "Path 13367",
    d: "M10.667,23.167A.669.669,0,0,0,10,22.5H6.667a.667.667,0,0,0,0,1.333H10A.669.669,0,0,0,10.667,23.167Z",
    transform: "translate(-6 -15.167)",
    fill: "#868a97"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13368",
    "data-name": "Path 13368",
    d: "M23.167,31.5a.669.669,0,0,0-.667.667V35.5a.667.667,0,0,0,1.333,0V32.167A.669.669,0,0,0,23.167,31.5Z",
    transform: "translate(-15.167 -20.167)",
    fill: "#868a97"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13369",
    "data-name": "Path 13369",
    d: "M23.167,6a.669.669,0,0,0-.667.667V10a.667.667,0,1,0,1.333,0V6.667A.669.669,0,0,0,23.167,6Z",
    transform: "translate(-15.167 -6)",
    fill: "#868a97"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13370",
    "data-name": "Path 13370",
    d: "M30.386,16.915a.668.668,0,0,0,.913.246l2.887-1.667a.668.668,0,1,0-.667-1.158L30.631,16A.669.669,0,0,0,30.386,16.915Z",
    transform: "translate(-19.498 -10.581)",
    fill: "#868a97"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13371",
    "data-name": "Path 13371",
    d: "M12.335,27.331a.668.668,0,0,0-.912-.246L8.534,28.752A.668.668,0,0,0,9.2,29.911l2.887-1.667A.669.669,0,0,0,12.335,27.331Z",
    transform: "translate(-7.222 -17.665)",
    fill: "#868a97"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13372",
    "data-name": "Path 13372",
    d: "M28.244,30.622a.668.668,0,1,0-1.158.667l1.667,2.887a.668.668,0,1,0,1.158-.667Z",
    transform: "translate(-17.665 -19.493)",
    fill: "#868a97"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13373",
    "data-name": "Path 13373",
    d: "M15.494,8.544a.668.668,0,1,0-1.158.667L16,12.1a.668.668,0,0,0,1.158-.667Z",
    transform: "translate(-10.581 -7.227)",
    fill: "#868a97"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13374",
    "data-name": "Path 13374",
    d: "M27.331,12.335a.669.669,0,0,0,.913-.246L29.911,9.2a.668.668,0,0,0-1.158-.667l-1.667,2.888A.668.668,0,0,0,27.331,12.335Z",
    transform: "translate(-17.665 -7.222)",
    fill: "#868a97"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13375",
    "data-name": "Path 13375",
    d: "M16.915,30.386a.669.669,0,0,0-.913.246l-1.667,2.888a.668.668,0,1,0,1.158.667L17.161,31.3a.668.668,0,0,0-.246-.913Z",
    transform: "translate(-10.581 -19.498)",
    fill: "#868a97"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13376",
    "data-name": "Path 13376",
    d: "M34.176,28.752l-2.887-1.667a.668.668,0,1,0-.667,1.158l2.887,1.667a.668.668,0,1,0,.667-1.158Z",
    transform: "translate(-19.493 -17.665)",
    fill: "#868a97"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13377",
    "data-name": "Path 13377",
    d: "M8.544,15.494l2.888,1.667A.668.668,0,1,0,12.1,16L9.211,14.336a.668.668,0,0,0-.667,1.158Z",
    transform: "translate(-7.227 -10.581)",
    fill: "#868a97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus);
export default __webpack_public_path__ + "static/media/status.1aa449e609034d43fc7d166ff2fd6f64.svg";
export { ForwardRef as ReactComponent };